import { MODAL_REDUCER } from "../../constants/AppConstants";

const modalState = (data) => (dispatch) => {
  return dispatch({
    type: MODAL_REDUCER,
    payload: data,
  });
};

export { modalState };